module.exports = __webpack_public_path__ + "static/img/bg4@2x.d3135e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/bg4@2x.png
// module id = w5iq
// module chunks = 69